import type { Field } from "../types/field";

export const validateFieldsData = (data: any) => {
  if (
    data &&
    typeof data[0].id === "string" &&
    typeof data[0].before === "string" &&
    typeof data[0].after === "string" &&
    typeof data[0].value === "string"
    // (typeof data[0].value === "string" || Array.isArray(data[0].value))
  ) {
    return data as Field[];
  } else {
    alert("Data stracture is not matched.");
    return;
  }
};
